import { render, staticRenderFns } from "./ConfirmOrderGuest.vue?vue&type=template&id=49b18a29&scoped=true&"
import script from "./ConfirmOrderGuest.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrderGuest.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmOrderGuest.vue?vue&type=style&index=0&id=49b18a29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b18a29",
  null
  
)

export default component.exports